import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-expensefilter',
  templateUrl: './expensefilter.component.html',
  styleUrls: ['./expensefilter.component.scss']
})
export class ExpensefilterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
